import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';
import { AuthService } from '../auth/auth.service';
import { Configuration } from '../configuration';

@Injectable()
export class PermissionsHub {
    private static hubConnection: HubConnection;
    private static authService: AuthService;
    private static userId: number;

    static startHub(authService: AuthService, config: Configuration, userId: number) {
        if (!this.hubConnection) {
            this.hubConnection = new HubConnectionBuilder()
                .configureLogging(LogLevel.Trace)
                .withUrl(`${config.routing.signalRHubs}/permissionsHub`)
                .build();

            this.hubConnection.on('RefreshPermissions',
                () => {
                    if (this.authService) {
                        this.authService.getNewToken().subscribe(() => {
                            this.hubConnection.invoke('Acknowledge', this.userId);

                            var permissionsRefreshed = sessionStorage.getItem('permissionsRefreshed');

                            if (permissionsRefreshed != 'true') {
                                sessionStorage.setItem('permissionsRefreshed', 'true');
                                window.location.reload();
                            }
                        });
                    }
                });
        }

        this.authService = authService;

        if (this.hubConnection.state == HubConnectionState.Disconnected) {
            try {
                this.hubConnection.start()
                    .then(() => {
                        this.userId = userId;
                        this.hubConnection.invoke('Login', this.userId);
                    })
                    .catch(err => { console.error(err.toString()); });
            } catch (e) {
                console.error(e.toString());
            }
        }
    }

    static stopHub() {
        if (this.hubConnection) {
            this.hubConnection.invoke('Logout', this.userId).then(() => {
                this.hubConnection.stop();
            });
        }

        this.authService = null;
    }

    static subscribeToHubEvent(event: string, callback: (data: any) => void) {
        this.hubConnection.on(event, callback);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/signalr/permissions.hub.ts